import { render } from "./AiGenerationMarketDefinition.vue?vue&type=template&id=25a6a4f6&scoped=true"
import script from "./AiGenerationMarketDefinition.vue?vue&type=script&lang=js"
export * from "./AiGenerationMarketDefinition.vue?vue&type=script&lang=js"

import "./AiGenerationMarketDefinition.vue?vue&type=style&index=0&id=25a6a4f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a6a4f6"]])

export default __exports__